export default __webpack_public_path__ + "static/tree-795a27883090340315adbde71668dd4b.svg";